import { render, staticRenderFns } from "./CardLabels.vue?vue&type=template&id=ba6f723a&scoped=true&"
import script from "./CardLabels.vue?vue&type=script&lang=js&"
export * from "./CardLabels.vue?vue&type=script&lang=js&"
import style0 from "./CardLabels.vue?vue&type=style&index=0&id=ba6f723a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f723a",
  null
  
)

export default component.exports